import { render } from "./BrandsMenu.vue?vue&type=template&id=468f934d"
import script from "./BrandsMenu.vue?vue&type=script&lang=js"
export * from "./BrandsMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__